import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './Whyus.css';

const Whyus = ({ content }) => (
  <section className="why"><div className="why__container">
    <motion.div className="why__text" initial="hidden" whileInView="visible" viewport={{ once: true, margin: '-100px' }}>
      {content.paragraphs.map((paragraph) => <motion.p key={paragraph} initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}>{paragraph}</motion.p>)}
      <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}><Link to={content.button.href} className="why__btn">{content.button.label}<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg></Link></motion.div>
    </motion.div>
    <motion.figure className="why__media" initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true, margin: '-100px' }} whileHover={{ scale: 1.02 }}><div className="why__image-container"><img src={content.image.src} alt={content.image.alt} loading="lazy" className="why__image" /><div className="why__image-overlay"></div></div></motion.figure>
  </div></section>
);

export default Whyus;
